export default "__VITE_ASSET__601f6397__"